/**
 * If you use this function, the controller needs an instsance of:
 * - $scope on the scope property
 * - $injector on the injector property
 * - a allowRoute property (you don't have to initialize it, but on leaving page, you have to set it to true)
 * @param controller
 * @param callback (if set, should be callable)
 */

export default function askForLeavingWithoutSavingChanges(controller, callback) {
    if (_.isUndefined(controller.allowRoute)) {
        controller.allowRoute = false;
    }

    const $translate = controller.injector.get('$translate'),
        translatedValue = (path) => {
            return $translate.instant(`core.helpers.routing.ask-for-leaving-without-saving-changes.${path}`);
        };

    const deregisterFn = controller.injector.get('$transitions').onBefore({}, trans => {
        return new Promise((resolve, reject) => {
            if (controller.allowRoute) {
                return resolve(trans);
            }

            controller.injector.get('Alert').animatedAlert(
                translatedValue('title'),
                translatedValue('content'),
                'attention',
                {
                    confirmButtonText: translatedValue('confirm'),
                    cancelButtonText: translatedValue('cancel'),
                },
            ).then(() => {
                controller.allowRoute = true;
                resolve(trans);
            }, () => {
                controller.allowRoute = false;
                resolve(false);
            });

            if (_.isFunction(callback)) {
                callback();
            }
        });
    });

    controller.scope.$on("$destroy", () => {
        deregisterFn();
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/core/helpers/routing/ask-for-leaving-without-saving-changes.js